import React from "react";
import PropTypes from "prop-types";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "@mui/material/Button";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import Config from "conFig.js";
import { Error, Success } from "../../../assets/jss/util/messageUtil";

const Themnoidung = React.memo(function Themnoidung(props) {
  const { thangnam } = props;
  const [thuanloikhokhan, setThuanloikhokhan] = React.useState("");
  const [dexuat, setDexuat] = React.useState("");
  const [alert, setAlert] = React.useState(false);
  const [alert1, setAlert1] = React.useState(false);
  const [alertValidate, setAlertValidate] = React.useState(false);
  const [messageValidate, setMessageValidate] = React.useState("");
  const token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  const getkhokhandexuat = () => {
    if (thangnam) {
      var thang = String(thangnam.$M + 1).padStart(2, "0") + "/" + thangnam.$y;
      var url =
        Config.backend +
        "/api/Canhbao/getbckhokhandexuatthang?thang=" +
        thang +
        "&baocao_id=3" +
        "&username=" +
        username;
      fetch(url, obj)
        .then((res) => res.json())
        .then((data) => {
          if (data.length > 0) {
            setThuanloikhokhan(data[0].khokhan);
            setDexuat(data[0].dexuat);
          }
        })
        .catch((error) => {
          console.error("Error fetching data: ", error);
        });
    }
  };
  const insertnoidung = () => {
    let mess = validateThem();
    if (mess === Success.SC0001) {
      var thang = String(thangnam.$M + 1).padStart(2, "0") + "/" + thangnam.$y;
      var url = Config.backend + "/api/Canhbao/themkhokhandexuat";
      fetch(url, {
        method: "POST",
        headers: {
          Accept: "application/json, text/plain",
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          thang: thang,
          baocao_id: 3,
          khokhan: thuanloikhokhan,
          dexuat: dexuat,
          username: username,
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data === 1) {
            showNotification();
          } else showNotification1();
        })
        .catch((error) => {
          console.error("Error fetching data: ", error);
        });
    } else {
      setMessageValidate(mess);
      showNotificationValidate();
    }
  };
  const showNotificationValidate = () => {
    setAlertValidate(true);
    setTimeout(function () {
      setAlertValidate(false);
    }, 6000);
  };
  const showNotification = () => {
    setAlert(true);
    setTimeout(function () {
      setAlert(false);
    }, 2000);
  };
  const showNotification1 = () => {
    setAlert1(true);
    setTimeout(function () {
      setAlert1(false);
    }, 2000);
  };
  const validateThem = () => {
    // Kiem tra cac truong bat buoc nhap
    if (thuanloikhokhan.trim() === "") {
      return Error.ER0063;
    }
    if (dexuat.trim() === "") {
      return Error.ER0064;
    }
    return Success.SC0001;
  };
  React.useEffect(() => {
    getkhokhandexuat();
  }, []);
  return (
    <div>
      <CardBody style={{ borderBottom: "1px solid #bbb" }}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: "10px" }}>
              <TextField
                label="Thuận lợi, khó khăn"
                variant="outlined"
                size="small"
                value={thuanloikhokhan}
                onChange={(event) => {
                  setThuanloikhokhan(event.target.value);
                }}
                multiline
                rows={3}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: "10px" }}>
              <TextField
                label="Đề xuất, kiến nghị"
                variant="outlined"
                size="small"
                value={dexuat}
                onChange={(event) => {
                  setDexuat(event.target.value);
                }}
                multiline
                rows={3}
              />
            </FormControl>
          </GridItem>
        </GridContainer>
      </CardBody>
      {/** fix css */}
      <CardFooter style={{ marginBottom: "20px" }}>
        <Button
          color="primary"
          variant="contained"
          style={{ height: 27 }}
          onClick={insertnoidung}
        >
          Cập nhật
        </Button>
      </CardFooter>
      <GridContainer>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="info"
            icon={AddAlert}
            message="Cập nhật thành công"
            open={alert}
            closeNotification={() => setAlert(false)}
            close
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="warning"
            icon={AddAlert}
            message="Có lỗi trong quá trình cập nhật"
            open={alert1}
            closeNotification={() => setAlert1(false)}
            close
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="warning"
            icon={AddAlert}
            message={messageValidate}
            open={alertValidate}
            closeNotification={() => setAlertValidate(false)}
            close
          />
        </GridItem>
      </GridContainer>
    </div>
  );
});
Themnoidung.propTypes = {
  thangnam: PropTypes.object,
};
export default Themnoidung;
